import './card-reset-pin.scss';
import { useSelector, useDispatch } from 'react-redux';
import { cardsResetPinRequest } from 'actions/cardActions';
import { trackCustomEvent } from 'utilities/app-insights';
import SmallPanel, { PanelButton } from 'features/cards/modals/card-detail-modal/SmallPanel';
import { ButtonType } from '@ampol/design-system';

interface CardResetPinProps {
  closeForm: () => void;
  cardsList: string[];
  parentAccountNumber?: string;
  disabled?: boolean;
  headless?: boolean;
}

/**
 * An all-purpose action modal container
 * @param children Child | child[] component(s) child to be rendered inside this modal
 * @param closeForm Close model event
 * @param submitClick Submit model event
 * @param cardsList Array of selected cards
 * @returns JSX Element
 */
const CardResetPin = ({ closeForm, cardsList, parentAccountNumber, disabled, headless }: CardResetPinProps) => {
  const dispatch = useDispatch();

  const readOnly = !useSelector((state: any) => state.userStore.canReadWriteCards);
  const assignedGrandfatherClientNumber = useSelector((state: any) => state.userStore.assignedGrandfatherClientNumber);
  const loggedInUser = useSelector((state: any) => state.userStore.loggedInUser);
  const assignedAccountNumber = useSelector((state: any) => state.userStore.assignedAccountNumber);

  const handleSubmitClick = () => {
    if (readOnly) {
      return;
    }
    window.dataLayer.push({
      event: 'Card_Portal_Individual_Card_Detail_Reset_Pin',
      button_click: true,
    });

    if (headless) {
      dispatch(cardsResetPinRequest(cardsList, assignedGrandfatherClientNumber, assignedGrandfatherClientNumber));
    } else {
      dispatch(cardsResetPinRequest(cardsList, parentAccountNumber, assignedGrandfatherClientNumber));
    }

    trackCustomEvent(
      'Submit Reset Pin',
      loggedInUser,
      assignedAccountNumber,
      'Clicked Send button to submit Reset Pin.',
      { selectedCard: cardsList }
    );
    closeForm();
  };

  const buttons: PanelButton[] = [
    {
      label: 'send',
      type: ButtonType.Button,
      onClick: handleSubmitClick,
    },
  ];

  return (
    <SmallPanel title="Reset PIN request" disabled={disabled} headless={headless} buttons={buttons}>
      {cardsList && cardsList.length > 0 && (
        <div>{`${cardsList.length} ${cardsList.length > 1 ? 'cards' : 'card'} selected for reset PIN request`}</div>
      )}
      {!cardsList && <div>Request PIN reset for this card.</div>}
    </SmallPanel>
  );
};

export default CardResetPin;
